import request from '@/utils/request';

/**
 * 获取收货地址列表
 * @returns
 */
export function getAddressList() {
  return request({
    url: '/system/front/recipient/list',
    method: 'get'
  });
}

/**
 * 获取收货地址详情
 * @returns
 */
export function getAddressDetail(id) {
  return request({
    url: '/system/front/recipient/' + id,
    method: 'get'
  });
}

/**
 * 新增收货地址
 * @returns
 */
export function addAddress(data) {
  return request({
    url: '/system/front/recipient',
    method: 'post',
    data
  });
}

/**
 * 编辑收货地址
 * @returns
 */
export function editAddress(id, data) {
  return request({
    url: '/system/front/recipient',
    method: 'put',
    data: {
      ...data,
      id
    }
  });
}

/**
 * 删除收货地址
 * @returns
 */
export function deleteAddress(id) {
  return request({
    url: '/system/front/recipient/' + id,
    method: 'delete'
  });
}



// WEBPACK FOOTER //
// ./src/api/address/index.js